import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { asArray, displayValue, getDataValue, getEntryTimestamp, limitRows } from '../utils';

const Settings = {
  Name: 'DataTable',
  Display: true,
  options: {
    view: null,
    settings: [
      { id: 'title', type: 'text', name: 'Title' },
      { id: 'number', type: 'number', name: 'Number of records', min: 1, max: 50, default: 10 },
      { id: 'showTime', type: 'switch', name: 'Show time column', default: true },
      { id: 'emptyText', type: 'text', name: 'Empty text', default: '-' },
      {
        id: 'columns',
        type: 'array',
        settings: [
          { id: 'label', type: 'text', name: 'Column label' },
          { id: 'id', type: 'text', name: 'Data path' },
        ],
      },
    ],
    grid: false,
  },
};

const View = ({ DeviceData, Settings: userSettings = {} }) => {
  const rows = limitRows(DeviceData, userSettings.number || 10);
  const columns = asArray(userSettings.columns).filter((column) => column?.id);
  const emptyText = userSettings.emptyText || '-';

  if (!rows.length) return <Box>No data.</Box>;
  if (!columns.length) return <Box>Table columns are not configured.</Box>;

  return (
    <Box>
      {userSettings.title ? (
        <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>{userSettings.title}</Typography>
      ) : null}
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              {userSettings.showTime !== false ? <TableCell>Time</TableCell> : null}
              {columns.map((column) => (
                <TableCell key={column.id}>{column.label || column.id}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, rowIndex) => {
              const timestamp = getEntryTimestamp(row);
              return (
                <TableRow key={row?.id || `${timestamp || 'row'}-${rowIndex}`}>
                  {userSettings.showTime !== false ? (
                    <TableCell>{timestamp ? new Date(timestamp).toLocaleString('en-AU') : emptyText}</TableCell>
                  ) : null}
                  {columns.map((column) => (
                    <TableCell key={column.id}>{displayValue(getDataValue(row, column.id), emptyText)}</TableCell>
                  ))}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default {
  Settings,
  View,
};
